import { EXTERNAL_TEST_USER_EMAILS as envTestUserEmails } from '@/environment';

/** @public */
export const EXTERNAL_TEST_USER_EMAILS: readonly string[] = [
  ...(envTestUserEmails ? envTestUserEmails.split(',') : []),
] as const;

export function isTestUserEmail(email: string): boolean {
  return EXTERNAL_TEST_USER_EMAILS.includes(email);
}

/** @public */
export const SINDI_USER_DOMAINS: readonly string[] = [
  'sindilabs.com',
  'socialindexforimprovement.com',
  'sindi.se',
] as const;

export function isSindiUserEmail(email: string): boolean {
  return SINDI_USER_DOMAINS.some((domain) => email.includes(domain));
}
